enum RouteName {
  About = 'about',
  Blog = 'blog',
  Runs = 'runs',
}

export default RouteName;
